/**
 * What the web app offers.
 *
 * WEB_CHAT is off since 2026-10-19 (the owner): an account's chats live on
 * ONE phone (docs/one-chat-phone-plan.md), and the browser held a second
 * set of keys that every sender had to encrypt for and that asked the phone
 * for history and room keys - the source of a whole class of chat bugs. The
 * web keeps the feed and the wallet. The server refuses a browser's chat
 * keys once the one-phone rule is on, whatever this says; turning this back
 * on needs that rule to make room for a linked browser first.
 */
export const WEB_CHAT = false;
